<template>
  <div>
    <div class="closeCurrntPage" @click="closeCurrntPage">X关闭当前页</div>
    <div class="head">
      <span>是否已生成采购订单</span>
      <el-select v-model="checkboxGroup" size="mini" placeholder="请选择" clearable @change="checkboxHandler">
        <el-option label="是" :value="1">
        </el-option>
        <el-option label="否" :value="0">
        </el-option>
      </el-select>
    </div>
    <el-table v-loading="loading" @selection-change="selectOrder" :data="tableData" show-summary
      :summary-method="getSummaries" border>
      <el-table-column type="selection" width="55" fixed="left">
      </el-table-column>
      <el-table-column type="index" label="序号">
      </el-table-column>
      <el-table-column prop="created_at" label="推送日期" width="70px">
      </el-table-column>
      <el-table-column prop="main_number" label="主订单号" width="130px">
      </el-table-column>
      <el-table-column prop="serial_number" label="编号">
        <template slot-scope="scope">
          <span v-if="scope.row.serial_number">{{ scope.row.serial_number.split('-').slice(3).join('-') }}</span>
          <span v-if="scope.row.express && isZhifaOrFactory">({{ scope.row.express }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_number" label="子订单号" width="130px">
      </el-table-column>
      <el-table-column prop="ruigu_code" label="商品编码" width="80px">
      </el-table-column>
      <el-table-column prop="self_code" label="三方商品编码">
      </el-table-column>
      <el-table-column prop="name" label="商品名称">
      </el-table-column>
      <el-table-column prop="spec" label="规格">
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="50px">
      </el-table-column>
      <el-table-column label="订购金额" prop="order_price" width="60px">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.price * scope.row.print_num}}</div>
        </template> -->
      </el-table-column>
      <el-table-column prop="price" label="单价" width="60px">
      </el-table-column>
      <el-table-column prop="amount" label="订购数量" width="60px">
      </el-table-column>
      <el-table-column prop="send_amount" label="实发数量" width="60px">
      </el-table-column>
    </el-table>
    <div class="select-total-wrap">
      <div>选中合计</div>
      <div>主订单数量: <span>{{ selectTotal.mainTotal }}</span></div>
      <div>子订单数量: <span>{{ selectTotal.orderTotal }}</span></div>
      <div>订购金额: <span>{{ selectTotal.priceTotal }}</span></div>
    </div>
    <div class="time-wrap">
      <div>签订时间:{{ nowTime }}</div>
      <div>预计交货:
        <el-date-picker size="mini" v-model="checkTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
    </div>
    <div style="text-align:center;">
      <el-button @click="setOrder" type="primary" size="mini">生成采购订单</el-button>
    </div>
    <div class="print-purchase">
      <div style="text-align:center;">
        <h4>采购订单</h4>
      </div>
      <table border="1" style="border-bottom:none;" width="100%" align="center" border-collapse="collapse">
        <tr>
          <td :colspan="colspan" class="inner-table-td">
            <div class="inner-table">
              <table width="100%" border-collapse="collapse">
                <thead>
                  <tr>
                    <td><span>签订时间：{{ nowTime }}</span></td>
                    <td><span>预计交货：{{ checkTime }}</span></td>
                  </tr>
                  <tr>
                    <td><span> 平台方：上海鑫谊麟禾科技有限公司</span></td>
                    <td><span> 供货方：{{ printPurchaseData.CompanyName }}</span></td>
                  </tr>
                  <tr>
                    <td><span> 平台代理人：</span></td>
                    <td><span> 供方代理人：{{ printPurchaseData.CompanyRepresentative }}</span></td>
                  </tr>
                  <tr>
                    <td><span> 联系电话：021-31762063</span></td>
                    <td><span> 供方电话：{{ printPurchaseData.CompanyRepresentativeMobile }}</span></td>
                  </tr>
                </thead>
              </table>
            </div>
          </td>
        </tr>
        <thead style="display: table-header-group; font-weight: bold">
          <tr>
            <!-- <td
              align="center"
              style="font-weight: bold;"
            >
              表头
            </td>
            <td
              align="center"
              style="font-weight: bold;"
            >
              表头2
            </td> -->
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr>
            <th><span>序号</span></th>
            <!-- <th><span>推送日期</span></th> -->
            <th><span>主订单号</span></th>
            <!-- <th><span>编号</span></th> -->
            <th><span>子订单号</span></th>
            <th><span>商品编码</span></th>
            <th><span>三方商品编码</span></th>
            <th><span>商品名称</span></th>
            <th><span>规格</span></th>
            <th><span>单位</span></th>
            <th><span>订购金额</span></th>
            <th><span>单价</span></th>
            <th><span>订购数量</span></th>
            <th><span>实发数量</span></th>
          </tr>
          <tr v-for="(item, index) in selectOrderData" :key="item.id">
            <td><span>{{ index + 1 }}</span></td>
            <!-- <td><span>{{item.created_at}}</span></td> -->
            <td><span>{{ item.main_number }}</span></td>
            <!-- <td>
              <span v-if="item.serial_number">{{item.serial_number.split('-').slice(3).join('-')}} <span v-if="item.express && isZhifaOrFactory">({{item.express}})</span></span>
            </td> -->
            <td><span>{{ item.order_number }}</span></td>
            <td><span>{{ item.ruigu_code }}</span></td>
            <td><span>{{ item.self_code }}</span></td>
            <td><span>{{ item.name }}</span></td>
            <td><span>{{ item.spec }}</span></td>
            <td><span>{{ item.unit }}</span></td>
            <td><span>{{ item.order_price }}</span></td>
            <td><span>{{ item.price }}</span></td>
            <td><span>{{ item.amount }}</span></td>
            <td><span>{{ item.send_amount }}</span></td>
          </tr>
          <tr>
            <td colspan="8" style="text-align:left;"><span style="font-weight:600;">合计</span></td>
            <td><span>{{ printTableDataTotal }}</span></td>
            <td></td>
            <td><span>{{ printTableNumTotal }}</span></td>
            <td><span>{{ printTableSendTotal }}</span></td>
          </tr>
          <tr>
            <td :colspan="colspan" class="inner-table-td footer-table" style="border-bottom:1px solid #999;">
              <div class="inner-table">
                <table height="200px" width="100%" border-collapse="collapse">
                  <tr>
                    <td style="width:100px;">
                      <span>
                        平台方评审：
                      </span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                    <td style="width:100px;">
                      <span>供货单位：</span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:100px;">
                      <span>经办人：</span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                    <td style="width:100px;">
                      <span>经办人：</span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:100px;">
                      <span>负责人：</span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                    <td style="width:100px;">
                      <span>单位盖章：</span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:100px;">
                      <span>
                      </span>
                    </td>
                    <td>
                      <span>
                      </span>
                    </td>
                    <td style="width:100px;"><span>签订日期：</span></td>
                    <td>
                      <span>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td :colspan="colspan" style="text-align:left;padding:5px 0;border:0;">注：本单为采购意向单，商品采购以供货方最终实际供货情况为准。</td>
          </tr>
        </tbody>
        <tfoot style="display:table-footer-group; font-weight: bold;">
          <tr>
            <td :colspan="colspan" align="center" class="footer">
              <img class="zhang" src="./../../assets/img/zhang.png" alt="" width="160px">
            </td>
          </tr>
        </tfoot>
      </table>
      <!-- <div><span>注：本单为采购意向单，商品采购以供货方最终实际供货情况为准。</span></div> -->
    </div>
  </div>
</template>

<script>
import { getPurchaseList, printPurchaseList } from '@/models/orderModel'
import moment from 'moment'
import { setTimeout } from 'timers'
export default {
  data() {
    return {
      isZhifaOrFactory: true,
      printPurchaseData: {
        CompanyName: '',
        CompanyRepresentative: '',
        CompanyRepresentativeMobile: ''
      },
      tableData: [],
      checkboxGroup: 0,
      loading: true,
      selectTotal: {
        mainTotal: 0,
        orderTotal: 0,
        priceTotal: 0
      },
      selectOrderData: [],
      printTableDataTotal: 0,
      printTableSendTotal: 0,
      printTableNumTotal: 0,
      nowTime: moment().format('YYYY-MM-DD'),
      checkTime: moment().format('YYYY-MM-DD'),
      colspan: 12
    }
  },
  created() {
    this.getPurchaseList()
  },
  methods: {
    moment,
    closeCurrntPage() {
      if (localStorage.getItem('is_jgj') === '1') {
        // 为紧固件
        this.$router.push('/bigorder/manageFastener')
      } else {
        this.$router.push('/bigorder/manage')
      }
    },
    getPurchaseList() {
      this.loading = true
      let params = { order_type: 1 }
      if (typeof this.checkboxGroup === 'number') {
        params.is_purchase = this.checkboxGroup
      }
      getPurchaseList(params)
        .then(res => {
          res.data.list.forEach(item => {
            item.order_price = (item.price * item.amount).toFixed(2)
          })
          this.tableData = res.data.list
          this.loading = false
        })
    },
    getSummaries(param) {
      const { columns, data } = param
      const count = (val, fixed) => {
        let c = ''
        if (!val.every(value => isNaN(value))) {
          c = (val.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)).toFixed(fixed)
        } else {
          c = ''
        }
        return c
      }
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (index === 0) {
          sums[index] = '合计'
        } else if (index === 13 || index === 14) {
          sums[index] = count(values, 0)
        } else if (index === 11) {
          sums[index] = count(values, 2)
        }
      })
      return sums
    },
    selectOrder(val) {
      this.selectOrderData = val
      console.log(val, '选择数据')
      let mainTotal = []
      let orderTotal = []
      let priceTotal = []
      if (val.length > 0) {
        val.forEach(item => {
          mainTotal.push(item.main_number)
          orderTotal.push(item.order_number)
          priceTotal.push(item.order_price)
        })
        this.selectTotal.mainTotal = [...new Set([...mainTotal])].length
        this.selectTotal.orderTotal = orderTotal.length
        this.selectTotal.priceTotal = priceTotal.reduce((pre, curr) => {
          return Number(pre) + Number(curr)
        }, 0).toFixed(2)
      }
    },
    checkboxHandler() {
      this.getPurchaseList()
    },
    setOrder() {
      // this.print()
      if (this.selectOrderData.length > 0) {
        let params = []
        let total = 0
        let sendTotal = 0
        let numTotal = 0
        this.selectOrderData.forEach(item => {
          params.push(item.id)
          total += Number(item.order_price)
          sendTotal += Number(item.send_amount)
          numTotal += Number(item.amount)
        })
        this.printTableDataTotal = total.toFixed(2)
        this.printTableSendTotal = sendTotal.toFixed(0)
        this.printTableNumTotal = numTotal.toFixed(0)
        printPurchaseList({
          ids: params.join(','),
          plan_transaction_date: this.checkTime
        })
          .then(res => {
            console.log(res, 'caigoudingdan ')
            this.printPurchaseData = res.data
            setTimeout(() => {
              this.print()
            }, 1000)
          })
      } else {
        this.$message.error('请选择')
      }
    },
    print() {
      let subOutputRankPrint = document.querySelector('.print-purchase')
      let newContent = subOutputRankPrint.innerHTML
      let oldContent = document.body.innerHTML
      document.body.innerHTML = newContent
      window.print()
      window.location.reload()
      document.body.innerHTML = oldContent
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  margin: 20px 0;

  span {
    display: inline-block;
    margin-right: 10px;
  }
}

.select-total-wrap {
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  padding-bottom: 10px;
  border-bottom: 1px solid #666;

  div {
    margin-right: 20px;

    span {
      color: blue;
    }
  }
}

.time-wrap {
  margin-top: 20px;
  display: flex;
  padding-bottom: 10px;
  align-items: center;

  div {
    margin-right: 20px;
  }
}

.closeCurrntPage {
  border-radius: 10px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  right: 16px;
  line-height: 20px;
  top: 53px;
  text-align: center;
  width: 94px;
  height: 20px;
  border-radius: 5px;
  background-color: white;
}

.print-purchase {

  width: 100%;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1000;

  table {
    border-spacing: 0;
    font-size: 12px;
    color: black;
    border-color: #EBEEF5;
    display: table;
    padding: 0;
    margin: 0;
  }

  table th {
    font-weight: bold;
  }

  table th,
  td {
    // padding: 5px 10px;
    padding: 0;
    margin: 0;

    span {
      display: inline-block;
      padding: 7px 3px;
    }
  }

  .inner-table-td {
    padding: 0;
    margin: 0;
  }

  .inner-table {
    table {
      border-collapse: collapse;
      padding: 0;
      margin: 0;
    }

    table td {
      border-top: 0;
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      border-left: 0;
      padding: 0;
      margin: 0;
      text-align: left;

      span {
        display: inline-block;
        padding: 10px 3px;
      }
    }

    /* css3样式，获取表格的最后一行 */
    table tr:last-child td {
      border-bottom: 0;
    }

    /* css3样式，获取表格的最后一列 */
    table tr td:last-child {
      border-right: 0;
    }
  }

  .footer {
    position: relative;
    // height: 200px;
    text-align: center;
    border: none;
  }

  .zhang {
    z-index: 1;
    position: absolute;
    bottom: 10px;
    left: 150px;
  }

  .footer-table {
    height: 200px;
  }
}

@media print {

  // table{
  //   page-break-after:always
  // }
  table {
    border-spacing: 0;
    font-size: 12px;
    color: black;
    border-color: #EBEEF5;
    display: table;
    padding: 0;
    margin: 0;
    // page-break-after:always
  }

  table th {
    font-weight: bold;
  }

  table th,
  td {
    // padding: 5px 10px;
    padding: 0;
    margin: 0;

    span {
      display: inline-block;
      padding: 7px 3px;
    }
  }

  .no-print {
    display: none;
  }

  .inner-table-td {
    padding: 0;
    margin: 0;
  }

  .inner-table {
    table {
      border-collapse: collapse;
      padding: 0;
      margin: 0;
    }

    table td {
      border-top: 0;
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      border-left: 0;
      padding: 0;
      margin: 0;
      text-align: left;

      span {
        display: inline-block;
        padding: 10px 3px;
      }
    }

    /* css3样式，获取表格的最后一行 */
    table tr:last-child td {
      border-bottom: 0;
    }

    /* css3样式，获取表格的最后一列 */
    table tr td:last-child {
      border-right: 0;
    }
  }

  tfoot {
    display: table-footer-group;
    font-weight: bold;
  }

  .footer {
    position: relative;
    // height: 200px;
    text-align: center;
    border: none;
  }

  .zhang {
    position: absolute;
    bottom: 10px;
    left: 150px;
  }

  .footer-table {
    height: 200px;
  }

  .print-purchase {
    // display: table;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/prinPurchase.vue